<template>
  <div class="main-card p-4 w-100 shadow-sm">
    <div class="d-flex justify-content-center align-items-center gap-3 mb-4 mt-2">
      <div class="logo-wrapper logo-bg-blue">
        <img src="@/assets/img/nganluong/favicon-vimo.svg" />
      </div>
      <i class="bi bi-arrow-right text-primary"
        ><img src="@/assets/img/nganluong/icon-right.svg"
      /></i>
      <div class="logo-wrapper logo-bg-orange">
        <img src="@/assets/img/nganluong/favicon-nganluong.svg" />
      </div>
    </div>

    <div class="text-center mb-4">
      <h1 class="title-main fw-bold text-uppercase mb-2" style="font-size: 20px">
        Xác nhận đăng ký dịch vụ thanh toán
      </h1>
      <p class="subtitle mb-0 text-center">Với Công ty CP Cổng trung gian thanh toán Ngân Lượng</p>
    </div>

    <div class="info-box p-3 mb-3">
      <div class="d-flex info-text align-items-start mb-2">
        <span class="fw-bold text-dark" style="font-size: 0.9rem; color: #808890"
          >Thông tin Đơn vị</span
        >
      </div>
      <hr class="my-2" style="opacity: 0.5" />
      <div class="d-flex info-text align-items-start mt-3 mb-2">
        <div><img class="me-2" src="@/assets/img/nganluong/icon-company.svg" /></div>
        <span class="info-value fw-bold text-uppercase" style="word-break: break-all"
          >{{ query.customerName || getEmail }}
        </span>
      </div>
      <div class="d-flex align-items-center">
        <div class="info-label">
          <img class="me-2" src="@/assets/img/nganluong/icon-email.svg" />
        </div>
        <span class="info-value" style="word-break: break-all">{{ getEmail }}</span>
      </div>
    </div>

    <div class="checkbox-box p-3 mb-4">
      <div class="d-flex align-items-start">
        <b-form-checkbox
          v-model="isAgreed"
          button-variant="primary"
          size="lg"
          class=""
          style="font-size: 14px"
        >
          Chúng tôi đồng ý và yêu cầu Vi Mô chuyển hồ sơ, thông tin sang Ngân Lượng đăng ký Ngân
          hàng để mở dịch vụ; và miễn trừ mọi trách nhiệm phát sinh cho Vi Mô đối với việc chuyển
          giao này (trừ lỗi cố ý của Vi Mô).
          <a class="accept-term-condition" @click.stop="showPopupTermCondition" href="#">
            Chi tiết nội dung yêu cầu</a
          >.
        </b-form-checkbox>
      </div>
    </div>

    <b-button
      block
      :variant="isAgreed ? 'primary' : 'secondary'"
      class="w-100 fw-bold py-2 mb-2 btn-nl-confirm"
      :disabled="!isAgreed"
      @click="nextStep"
    >
      Xác nhận
    </b-button>

    <popup-term-condition ref="popupTermCondition" />
  </div>
</template>

<script>
  // import { contractNLOtp } from '@/services/customer-support/task'
  import PopupTermCondition from './PopupTermCondition.vue'

  export default {
    props: ['query', 'updateShowLoading'],
    components: {
      PopupTermCondition,
    },
    data() {
      return {
        isAgreed: false,
      }
    },
    computed: {
      getEmail() {
        return this.$options.filters.maskEmail(this.query.email)
      },
    },
    methods: {
      async nextStep() {
        // try {
        //   this.loadingBtn = true
        //   this.updateShowLoading(true)
        //   const res = await contractNLOtp({
        //     checksum: this.query.checksum,
        //     email: this.query.email,
        //     taskId: this.query.taskId,
        //     time: this.query.time,
        //   })
        //   if (res.code === 1000) {
        //     this.$emit('next-step')
        //   } else {
        //     this.showFailMx(res.message ?? res.error)
        //   }
        // } catch (error) {
        //   console.log('error::: ', error)
        //   this.showFailMx(
        //     error.response?.data?.message ? error.response.data.message : error.message
        //   )
        // } finally {
        //   this.loadingBtn = false
        //   this.updateShowLoading(false)
        // }
        this.$emit('show-popup-send-otp')
      },
      showPopupTermCondition() {
        this.$refs.popupTermCondition.show()
      },
    },
  }
</script>

<style lang="scss" scoped>
  a.accept-term-condition {
    color: #007bff;
    background-color: transparent;
    text-decoration: underline;

    &:hover,
    &:focus {
      color: #007bff;
    }
  }
</style>
